import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bloque-quienes-somos',
  templateUrl: './bloque-quienes-somos.component.html',
  styleUrl: './bloque-quienes-somos.component.css'
})
export class BloqueQuienesSomosComponent {
  @Input() pageData;
  rutaImagenUno: string = '../../../../../assets/images/IMG_6229.jpg';
  rutaImagenDos: string = '../../../../../assets/images/IMG_9703.jpg';
}
